import { toEnglish } from './props'

export enum PersianMonths {
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
}

type detailDateType = {
  fullHour: string
  fullDate: string
  hour: string
  minute: string
  second: string
  day: string
  month: string
  year: string
}
export const getDateDetailFromTimestamp = (date: string): detailDateType => {
  const splited = date.split(' ')
  const daySplited = splited[0].split('-')
  const hourSplited = splited[1].split(':')
  return {
    fullHour: splited[1],
    hour: hourSplited[0],
    minute: hourSplited[1],
    second: hourSplited[2],
    fullDate: splited[0],
    day: daySplited[2],
    month: daySplited[1],
    year: daySplited[0],
  }
}

export const getPersianMonthName = (monthNum: string | number): string => {
  const value = typeof monthNum === 'string' ? toEnglish(monthNum) : monthNum
  return PersianMonths[+value - 1]
}

export const getDaysPassed = (day: string): string => {
  const dayDate = new Date(day).getTime()
  const today = new Date().getTime()
  const dayPassed = Math.round((today - dayDate) / (1000 * 60 * 60 * 24))
  if (dayPassed > 30) {
    return new Date(day).toLocaleDateString('fa-IR')
  } else {
    return `${dayPassed} روز پیش`
  }
}

export const getReservePeriod = (checkin: number, checkout: number): number => {
  const checkinDate = new Date(checkin).getTime()
  const checkoutDate = new Date(checkout).getTime()
  const reservePeriod = Math.round(
    (checkoutDate - checkinDate) / (60 * 60 * 24),
  )
  return reservePeriod
}

export const toJalaliDayMonth = (dateTimeStr: string) => {
  if (!dateTimeStr || typeof dateTimeStr !== 'string') {
    return null
  }

  const date = new Date(dateTimeStr.replace(' ', 'T'))

  if (isNaN(date.getTime())) {
    return null
  }

  const formatter = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
    day: 'numeric',
    month: 'long',
  })

  return formatter.format(date)
}
